import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./View.module.sass";
import Table from "../Table";
import Panel from "./Panel";
import { get_tags_barcode } from "../../../../../../API/TagBarcode";
import { useNavigate } from "react-router";
import Card from "../../../../../../components/Card";
import { useReactToPrint } from "react-to-print";

const View = () => {
  const navigate = useNavigate();
  const [barcodes, setBarcodes] = useState([]);
  const [visible, setVisible] = useState(false);
  const printRef = React.useRef();

  const fetchAllBarcodes = async () => {
    const res = await get_tags_barcode();
    setBarcodes(res.data);
  };

  useEffect(() => {
    fetchAllBarcodes();
  }, []);

  const handleCreateBarcode = () => {
    navigate("/settingsDashboard/camera&Barcode/actionBarcodesForTag/create");
  };

  const handlePrintAll = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Barcodes",
    pageStyle: "@page { size: A4; margin: 20mm; }",
  });

  return (
    <>
      <Card
        className={cn(styles.card)}
        title="Action Barcode for Tags"
        classTitle="title-purple"
      >
        <div className={styles.list}>
          <Table
            data={barcodes}
            className={styles.table}
            activeTable={visible}
            setActiveTable={setVisible}
            printRef={printRef}
          />
        </div>
      </Card>
      <div className="fixed bottom-7 left-30 right-5">
        <Panel
          onCreateClick={handleCreateBarcode}
          onPrintAllClick={handlePrintAll}
        />
      </div>
    </>
  );
};

export default View;
